import {
  Component,
  Element,
  Event,
  EventEmitter,
  Prop,
  State,
  Watch,
  h
} from "@stencil/core";

import { Control } from "@genexus/designer-common";

import { getBreadcrumb } from "../../../utils";
import { DesignerToolArrangeObserver } from "../designer-tool-arrange/designer-tool-arrange-observer";
import { DesignerToolSelectEvent } from "../designer-tools-types";

@Component({
  styleUrl: "designer-tool-breadcrumb.scss",
  tag: "gx-designer-tool-breadcrumb"
})
export class DesignerToolBreadcrumb {

  @Element() el: HTMLElement;
  @Prop() control: Control;
  @State() breadcrumb: Control[] = [];

  componentWillLoad() {
    this.loadBreadcrumb();
  }

  componentDidLoad() {
    DesignerToolArrangeObserver.observe(this.el);
  }

  disconnectedCallback() {
    DesignerToolArrangeObserver.unobserve(this.el);
  }

  @Watch("control")
  watchControl() {
    this.loadBreadcrumb();
  }

  @Event() selectControl: EventEmitter<DesignerToolSelectEvent>;

  handleBreadcrumbClick(control: Control, event: MouseEvent) {
    this.selectControl.emit({
      add: event.ctrlKey || event.metaKey,
      controlId: control.site.id
    });
    event.stopPropagation();
  }

  private loadBreadcrumb() {
    this.breadcrumb = getBreadcrumb(this.control);    
  }

  render() {
    return (
      <ul class="list">
        {this.breadcrumb.slice(0, 3).map(control => (
          <li
            class="item"
            onClick={this.handleBreadcrumbClick.bind(this, control)}
          >
            <gx-designer-tool-identity class="identity" control={control} />
          </li>
        ))}
      </ul>
    );
  }
}
